import { Component, OnInit, TemplateRef } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BsModalService } from 'ngx-bootstrap/modal';
import { General_Interface } from 'src/app/Interface/General_Interface';
import { Empty_Nav_Interface, Nav_Interface } from 'src/app/Interface/Nav_Interface';
import { Empty_Persone_List_Interface, Persone_List_Interface } from 'src/app/Interface/Persone_List_Interface';
import { Empty_User_Interface, User_Interface } from 'src/app/Interface/User_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { DeviceBehfaService } from 'src/app/Service/DeviceBehfa/DeviceBehfa.service';
import { LetterRequestCustomerService } from 'src/app/Service/Letter/LetterRequestCustomer.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { PersonService } from 'src/app/Service/Person/Person.service';
import { TicketCategoryService } from 'src/app/Service/TicketCategory/TicketCategory.service';
import { UserService } from 'src/app/Service/User/User.service';

@Component({
  selector: 'app-UserAdd',
  templateUrl: './UserAdd.component.html',
  styleUrls: ['./UserAdd.component.scss']
})
export class UserAddComponent implements OnInit {

  Token: String = ""

  constructor(
    private User_Service: UserService,
    private Nav_Service: NavService,
    private Alertify_Service: AlertifyService,
    private modalService: BsModalService,
    private Person_Service: PersonService,
  ) { }

  ngOnInit() {
    this.Token = localStorage.getItem('Daro_User_Token');

    this.AddNewUser = new FormGroup({
      id: new FormControl(),
      Username: new FormControl(null, Validators.required),
      Password: new FormControl(null, [Validators.required, Validators.minLength(6)]),
      Type: new FormControl("0"),
      ExpertCalibration: new FormControl("0"),
    })

    this.Nav_Service.CheckValidPage(this.Token, 22).subscribe(
      data => {

      }
      , error => {
        localStorage.clear()
        location.reload();
      }
    )

  }


  //#region  Form Add

  AddNewUser: FormGroup;

  get_Form_Username() {
    return this.AddNewUser.get('Username') as FormControl;
  }

  get_Form_Password() {
    return this.AddNewUser.get('Password') as FormControl;
  }

  get_Form_Type() {
    return this.AddNewUser.get('Type') as FormControl;
  }
  get_Form_ExpertCalibration() {
    return this.AddNewUser.get('ExpertCalibration') as FormControl;
  }

  //#endregion

  InProccessing: boolean = false

  SubmitAddNewUser() {

    if (Number(this.get_Form_Type().value) == 0) {
      this.Alertify_Service.ErrorMessage("Select the user type.")
    }
    else {

      var Record: User_Interface = Empty_User_Interface()
      Record.id = 0
      Record.password = this.get_Form_Password().value
      Record.username = this.get_Form_Username().value
      Record.type = Number(this.get_Form_Type().value)
      Record.person_id = this.selected_DataList_Persone_Record.id
      Record.expert_calibration = (Number(this.get_Form_ExpertCalibration().value) == 1)

      this.InProccessing = true
      this.User_Service.AddUser(Record,
        this.Token,
        [],
        [],
        [],
        [],
        []).subscribe(
          data => {
            this.InProccessing = false
            if (data.id == -2) {
              this.Alertify_Service.ErrorMessage("The entered username already exists in the list.")
            }
            else {
              this.AddNewUser.reset()
              this.Alertify_Service.SuccessMessage("Information saved successfully.")
              this.get_Form_Type().setValue("0")
              this.get_Form_ExpertCalibration().setValue("0")
              this.selected_DataList_Persone_Record = Empty_Persone_List_Interface()
              this.ReadData_Persone()
            }
          }, error => {
            localStorage.clear()
            location.reload();

          }
        )

    }

  }

  //#region Person

  page: number = 0;
  Filter_title: String = ''

  modalRef_Person: any;
  ProcssingPersone: boolean = false
  openModal_Customer(template: TemplateRef<any>) {
    this.modalRef_Person = this.modalService.show(template);
  }

  DataList_Persone: Array<Persone_List_Interface> = []
  selected_DataList_Persone_Record: Persone_List_Interface = Empty_Persone_List_Interface();


  selected_DataList_Persone(item) {
    this.selected_DataList_Persone_Record = item
    this.modalRef_Person.hide()
  }

  ReadData_Persone() {
    this.ProcssingPersone = true
    this.Person_Service.GetUser(this.Token).subscribe(
      data => {
        this.DataList_Persone = data
        this.ProcssingPersone = false
      }, error => {
        localStorage.clear()
        location.reload();

      }
    )
  }

  Change_Filter_title() {
    this.page = 0
  }

  //#endregion



}
